module.exports = __webpack_public_path__ + "images/research-icon.svg";